"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDactionState = exports.defaultDactionDistrictOptions = exports.defaultDactionSortOptions = void 0;
var DactionState_1 = require("@/pages/developments/states/daction/DactionState");
exports.defaultDactionSortOptions = [
    {
        id: 2,
        key: DactionState_1.DactionSortField.CREATED_DATE,
        name: 'Latest',
        order: DactionState_1.DactionSortOrder.DESC,
    },
    {
        id: 1,
        key: DactionState_1.DactionSortField.CREATED_DATE,
        name: 'Oldest',
        order: DactionState_1.DactionSortOrder.ASC,
    },
];
exports.defaultDactionDistrictOptions = [
    {
        id: 0,
        name: 'All Districts',
    },
];
exports.defaultDactionState = {
    nameFilter: 'Filter',
    nameSortBy: 'Sort By',
    nameClear: 'Clear',
    nameConfirm: 'Confirm',
    nameBack: 'Back',
    selectedSorting: 2,
    selectedDistrict: 0,
    sortOptions: exports.defaultDactionSortOptions,
    districts: exports.defaultDactionDistrictOptions,
};
